import React, { FC } from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';

import { useTranslation } from '../i18n';
import { CommonReferencePickerPlugin } from '../types/ReferencePickerPlugin';

interface EntityPickerModalEmptyStateProps {
  canCreate: boolean;
  onCreateClick: () => void;
  plugin: CommonReferencePickerPlugin;
}

const EntityPickerModalEmptyState: FC<EntityPickerModalEmptyStateProps> = ({
  canCreate,
  onCreateClick,
  plugin,
}) => {
  const { t } = useTranslation();
  const { CreateNewButtonText } = plugin ?? {};
  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_EMPTY_GREY}
      description={t('NO_DATA')}
    >
      {canCreate && (
        <LinkButton onClick={onCreateClick}>
          {CreateNewButtonText ? <CreateNewButtonText /> : t('CREATE')}
        </LinkButton>
      )}
    </EmptyState>
  );
};

export default EntityPickerModalEmptyState;
